import { StatisticsRepo } from "@app/core/statistics/domain/statistics.repo";
import { Observable } from "rxjs";
import { Statistics } from "@app/core/statistics/domain/model/statistics";
import { AggregateStatisticsWS } from "@app/core/statistics/data/network/aggregate-statistics.ws";
import { Injectable } from "@angular/core";
import { StatisticsSearchCriteria } from "@app/core/statistics/domain/statistics-search-criteria";
import { ListStatisticsWS } from "../network/list-statistics.ws";
import { AggregateStatisticsSampleWS } from "../network/aggregate-statistics.sample.ws";

@Injectable()
export class StatisticsDataRepo implements StatisticsRepo {
  constructor(
    private aggregateStatisticsWS: AggregateStatisticsWS,
    private listStatisticsWS: ListStatisticsWS,
    private aggregateStatisticsSampleWS: AggregateStatisticsSampleWS
  ) {}
  getAggregate(
    statisticsSearchCriteria: StatisticsSearchCriteria,
    token: string
  ): Observable<Statistics> {
    return this.aggregateStatisticsWS.execute(statisticsSearchCriteria, token);
  }

  getAggregateSample(
    statisticsSearchCriteria: StatisticsSearchCriteria,
    token: string | null
  ): Observable<Statistics> {
    return this.aggregateStatisticsSampleWS.execute(
      statisticsSearchCriteria,
      token
    );
  }

  getList(limit: number, token: string): Observable<Statistics> {
    return this.listStatisticsWS.execute(limit, token);
  }
}
